/**
 * @ngdoc directive
 * @name mpi_values
 *
 * @description
 *  MPI values
 */

module.directive('mpi_values', function(){
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            "url_to_call" : '@?',
            "idMerchant": '@?',
            "idSession": '@?',
            "amount": '@?',
            "currency": '@?',
            "CCNumber": '@?',
            "CExpDate": '@?',
            "CCVCode": '@?',
            "URLRetour": '@?',
            "URLHttpDirect": '@?'
        },
    }
});
